<template>
  <header class="common-header" :class="{add:isAdd}">
    <div class="header-wrap wrapper">
      <div class="logo">
        <div class="logo__img">
          <img class="img" src="/static/img/logo_w.png" />
        </div>
        <h1 class="logo__title">
          <router-link class="link" to="/">METADATA</router-link>
        </h1>
      </div>
      <div class="drop-menu" @click="showDropNav=!showDropNav" :class="{'is-active':isActive}">
        <i class="icon"></i>
      </div>
      <!-- 移动端 -->
      <ul v-show="showDropNav" class="drop-nav">
        <li v-for="(item,index) in navList" :key="index" class="drop-nav-item">
          <template v-if="item.subMenu">
            <ul>
              <li v-for="(subItem, idx) in item.subMenu" :key="idx">
                <a class="link" :to="subItem.router">{{subItem.title}}</a>
              </li>
            </ul>
          </template>
          <template v-else>
            <a class="link" @click="dropNavChange(item.router)">{{item.title}}</a>
          </template>
        </li>
      </ul>
      <!-- pc端导航 -->
      <ul class="nav">
        <li v-for="(item,index) in navList" :key="index" class="item" :class="{active: curIdx === index}" @click="curIdx = index">
          <template v-if="item.subMenu">
            <el-dropdown placement="bottom" @command="handleCommand">
              <router-link class="link" :to="item.router">{{item.title}}</router-link>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(subItem, idx) in item.subMenu" :key="idx" :command="subItem.id">{{subItem.title}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template v-else>
            <router-link class="link" :to="item.router">{{item.title}}</router-link>
          </template>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { NAV_MENU } from '@/assets/data/common'
export default {
  name: 'common-header',
  data () {
    return {
      navList: NAV_MENU,
      curIdx: 0,
      isAdd: false,
      showDropNav: false
    }
  },
  computed: {
    isActive () {
      return this.showDropNav
    }
  },
  watch: {
    $route: 'changeRouter'
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop > 80) {
        this.isAdd = true
      } else {
        this.isAdd = false
      }
    },
    handleCommand (val) {
      this.$router.push({ path: '/product', query: { id: val } })
    },
    changeRouter () {
      this.navList.forEach((item, index) => {
        if (this.$route.meta.title === item.title) {
          this.curIdx = index
        }
      })
    },
    dropNavChange (router) {
      this.$router.push(router)
      this.showDropNav = false
    }
  }
}
</script>

<style lang="less">
@primary: #23a07b;

.common-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 80px;
  transition: all 0.5s;
  &.add {
    background: @primary;
    box-shadow: 0 1px 5px 2px rgba(0, 0, 0, 0.1);
  }
  .header-wrap {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .logo {
    display: flex;
    align-items: center;
    &__img {
      width: 60px;
      height: 36px;
    }
    &__title {
      margin-left: 20px;
      font-size: 22px;
      .link {
        color: #fff;
      }
    }
  }
  .nav {
    display: flex;
    font-size: 18px;
    user-select: none;
    .item {
      width: 70px;
      height: 70px;
      line-height: 70px;
      margin: 0 10px;
      text-align: center;
      .link {
        display: inline-block;
        width: 100%;
        height: 100%;
        color: #fff;
      }
      &:hover {
        border-bottom: 2px solid #fff;
      }
      &.active {
        border-bottom: 2px solid #fff;
      }
      // 修改 element-ui
      .el-dropdown {
        width: 100%;
        font-size: 18px;
        a {
          outline: none;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .common-header {
    height: 60px;
    background: @primary;
    .header-wrap {
      height: 100%;
    }
    .logo {
      height: 100%;
      margin: 0 auto;
      &__img {
        width: 30px;
        height: 18px;
      }
      &__title {
        font-size: 15px;
      }
    }
    .nav {
      display: none;
    }
    .drop-menu {
      position: absolute;
      right: 10px;
      height: 100%;
      width: 40px;
      line-height: 60px;
      text-align: center;
      color: #fff;
      &.is-active {
        .icon {
          transform: rotateZ(90deg);
        }
      }
      .icon {
        width: 18px;
        height: 3px;
        display: inline-block;
        border-top: 9px double #fff;
        border-bottom: 3px solid #fff;
        transition: all 0.4s;
      }
    }
    .drop-nav {
      position: absolute;
      top: 60px;
      left: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 30px;
      background: #40bf8f;
      transition: all 0.4s;
      &-item {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #f1f1f1;
        font-size: 14px;
        padding-left: 5px;
        .link {
          display: inline-block;
          height: 100%;
          width: 100%;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonHeader.vue